export default {"src":"/_next/static/media/book-confidently.8b85eec1.svg","height":48,"width":56};